module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <span class=\"prop-header prop-label\">Page</span>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 prop-sublabel form-group-flex prop-separator-radio\">\r\n        <input type=\"radio\" name=\"pageType\" value=\"next\" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">Next</label>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 prop-sublabel form-group-flex prop-separator-radio\">\r\n        <input type=\"radio\" name=\"pageType\" value=\"previous\" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">Previous</label>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 prop-sublabel form-group-flex prop-separator-radio\">\r\n        <input type=\"radio\" name=\"pageType\" value=\"back\" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">Back to Last Shown</label>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 prop-sublabel form-group-flex prop-separator-radio\">\r\n        <input type=\"radio\" name=\"pageType\" value=\"specific\" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">Specific</label>\r\n    </div>\r\n    <div class=\"col-md-6\" style=\"margin-top: 5px;margin-left:15px;\">\r\n        <select id=\"pages\" name=\"page\" ")
    ; __append(escapeFn(specificDisabled))
    ; __append(" >\r\n        </select>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}